// 产品详情

import { useState, useEffect } from 'react'
import fun from './../../common/common_fun'
import url from './../../common/url_config'
import { Tag, Spin, Popover, DatePicker, message, Modal, Select, Button, Drawer, Switch } from 'antd'
import 'moment/locale/zh-cn';
import { VideoCameraOutlined, DesktopOutlined, GiftOutlined, VideoCameraAddOutlined, UnorderedListOutlined, MenuOutlined, ExportOutlined } from '@ant-design/icons';
import ReactEcharts from 'echarts-for-react'
import common_data from './../../common/common_data'
import Menu from '../../components/menu'
import cookie from 'react-cookies'
import huijv from './../../common/huijv'
import ModifyInfo from '../../components/modify_info'
import common_fun from './../../common/common_fun';
import screen_png from '../../img/screen.png'
import camera_png from '../../img/camera.png'
import MenuSolution from '../../components/menu/menu_solution'


function App(props: any) {
  let [loading, set_loading] = useState(false)//加载中
  let [loading_btn, set_loading_btn] = useState(false)//加载中
  let [visible, set_visible] = useState(false)//预定遮罩
  let [start_date, set_start_date] = useState('')
  let [order_date, set_order_date] = useState([])
  let [order_start_h, set_order_start_h] = useState('')
  let [order_start_m, set_order_start_m] = useState('')
  let [order_end_h, set_order_end_h] = useState('')
  let [order_end_m, set_order_end_m] = useState('')
  let [board_name, set_board_name] = useState('')
  let [detail, set_detail] = useState({ name_no_num: '', num: '', product_category: '', cpu_family: '', product_line: '', demo_name: '', format_url_board_product_category: '', format_url_board_cpu_family: '' })
  let [draw_visible, set_draw_visible] = useState(false)//抽屉展示
  let [my_co_info, set_my_co_info] = useState({})//完善企业信息
  let [visible_my_info, set_visible_my_info] = useState(false)//完善企业信息遮罩
  let [is_only_confirm_info, set_is_only_confirm_info] = useState(false)//是否仅确认信息
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文
  let [current_height, set_current_height] = useState(document.documentElement.clientHeight)//当前页面高度

  // 获取单条数据详情
  const get_data = (board_name: string) => {
    set_loading(true)
    fun['post_data'](url + 'get_board_detail', {
      board_name,
      time_zone_offset_hours: common_data.time_zone_offset_hours,
    }).then(res => {
      if (res.status) {
        console.log('查询单条数据详情', res.result,)

        let detail_parse = !res.result.detail ? [] : JSON.parse(res.result.detail).map((item: any) => {
          if (item['data_set']['length'] === 1 && !item['data_set'][0]) {
            item['data_set'] = []
          }
          if (item['data_set_en']['length'] === 1 && !item['data_set_en'][0]) {
            item['data_set_en'] = []
          }
          return item
        })
        console.log(detail_parse)
        set_detail({ ...res.result, detail_parse })
      } else {
        alert(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
      }
      set_loading(false)
    })
  }

  // 获取可预定日期的时间段
  const get_allow_time = (date: any) => {
    if (date < fun.formatDate(new Date())) {
      set_order_date([])
      message.error(current_language_ch ? '请选择正确的日期' : 'Please select the correct date !')
    } else {
      set_start_date(date)
      set_loading(true)
      let params = {
        time_zone_offset_hours: common_data.time_zone_offset_hours,
        start_date: date, board_name
      }
      console.log('params', params)
      fun['post_data'](url + 'get_enabled_time_new', params).then(res => {
        if (res.status) {
          let rows = res.result.map((item: any, index: number) => {
            if (index === 0) {
              item.allow_show = item.allow
            } else {
              if (item.allow && !res.result[index - 1]['allow']) {
                item.allow_show = false
              } else if (!item.allow && res.result[index - 1]['allow']) {
                item.allow_show = true
              } else {
                item.allow_show = item.allow
              }
            }
            item['label'] = (item['h'] < 10 ? ('0' + item['h']) : item['h']) + ':' + (item['m'] < 10 ? ('0' + item['m']) : item['m'])
            return ({ ...item })
          })
          rows = rows.concat([{ h: 0, m: 0, allow: false, allow_show: rows[rows.length - 1]['allow'], label: current_language_ch ? '当日结束' : 'Day Ended' }])
          console.log('可选时段', rows)
          set_order_date(rows)
        } else {
          alert(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
        }
        set_loading(false)
      })
    }
  }

  // 确认预定
  const confirm_order = () => {
    if (order_start_h !== '现在开始 / From Now') {
      if ((new Date(start_date).getTime() - new Date().getTime()) / (60000 * 60) > 192) {
        message.error(common_data.book_mention_1)
        return
      }
    }

    let order_time_index_set = fun.appoint_time(start_date, order_date, order_start_h, order_start_m, order_end_h, order_end_m)
    if (!order_time_index_set) {
      return
    }
    console.log('预定index', order_time_index_set)

    if (window.confirm(current_language_ch ? '确认预定' : 'Confirm Book')) {
      let cpu_family = detail['cpu_family']
      if (detail.demo_name) {
        cpu_family = detail.demo_name.toUpperCase() + ' ' + cpu_family
      }
      if (detail.product_category && detail.product_category.indexOf('FORLINX') === 0) {
        cpu_family = 'FORLINX ' + cpu_family
      }

      huijv.c_cloud_lab_website_board_order(cpu_family, board_name, { start_date, order_start_h, order_start_m, order_end_h, order_end_m })

      set_loading(true)
      fun['post_data'](url + 'appointment_watch_new_multiple', {
        time_zone_offset_hours: common_data.time_zone_offset_hours,
        start_date, board_name, order_time_index_set,
        is_from_now: order_start_h === '现在开始 / From Now',
        board_category: detail['product_category'],
        board_type: detail['type'],
        board_cpu_family: detail['cpu_family'],
        board_demo_name: detail['demo_name'],
        board_demo_name_set: detail['demo_name_set'] ? detail['demo_name_set'].split(',') : null,
      }).then(res => {
        if (res.status) {
          // if (detail['demo_name']) {
          //   for (let i in res.result) {
          //     if (!res.result[i]['status']) {
          //       alert(current_language_ch ? ('预定失败：' + JSON.stringify(res.result[i]['result'])) : ('Book Failed: ' + JSON.stringify(res.result[i]['result_en'])))
          //       set_loading(false)
          //       return
          //     }
          //   }

          //   set_visible(false)
          //   if (window.confirm(common_data.book_fuccessful_mention)) {
          //     window.location.href = '/my' + (current_language_ch ? '' : '?lan=en')
          //   }
          // } else {
          // if (detail['product_type'] === 'MCU' && order_start_h === '现在开始 / From Now') {
          //   fun['post_data'](url + 'get_temp_code', { board_name: detail['name'] }).then(res => {
          //   })
          // }

          set_visible(false)
          if (window.confirm(common_data.book_fuccessful_mention)) {
            window.location.href = '/my' + (current_language_ch ? '' : '?lan=en')
          }
          // }

          // EVSE允许控制画面
          cookie.save('has_allow_contrl', '', { path: '/' })
        } else {
          alert(current_language_ch ? ('预定失败：' + JSON.stringify(res.result)) : ('Book Failed: ' + JSON.stringify(res.result_en)))
        }
        set_loading(false)
      })
    }
  }

  useEffect(() => {
    // 从URL参数中获取开发板名称
    set_loading(true)
    fun['post_data'](url + 'get_board_name_by_format_url_board_name', {
      format_url_board_name: props.match.params.name,
    }).then(res => {
      if (res.status) {
        let query_board_name = res.result.name
        console.log('查询开发板名称', query_board_name)

        set_board_name(query_board_name)
        get_data(query_board_name)

        // 荟聚
        huijv.open_page({
          "targetName": "产品详情页" + (decodeURI(query_board_name)),
          "targetId": 'product_detail',
        })
      } else {
        alert(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
      }
      set_loading(false)
    })

    window.addEventListener('resize', (e: any) => {
      set_current_height(document.body.clientHeight)
    })
  }, [])

  return <div style={{ minHeight: current_height - 160 }}>
    {/* 预定遮罩 */}
    <Modal width={'90%'} destroyOnClose style={{ top: 10 }} visible={visible} title={common_data.select_book_date_title} footer={false} onCancel={() => set_visible(false)}>
      <div>
        <Switch onChange={e => {
          set_order_start_h(e ? '现在开始 / From Now' : '')
          if (e) {
            set_start_date(fun.formatDate(new Date()))
          }
        }} /><span style={{ marginRight: 10, marginLeft: 3 }}>{current_language_ch ? '立即使用' : 'USE NOW'}</span>

        {/* 取消日历 */}
        {/* {order_start_h !== '现在开始 / From Now' && <DatePicker placeholder={common_data.select_book_date_ipt} style={{ width: 300, }} onChange={(e, date) => {
          if ((new Date(date).getTime() - new Date().getTime()) / (60000 * 60) > 168) {
            message.error(common_data.book_mention_1)
          }
          get_allow_time(date)
          console.log(date)
        }} />} */}
        {order_start_h !== '现在开始 / From Now' && <Select placeholder={common_data.select_book_date_ipt} style={{ width: 300, }} onChange={(e: any) => {
          get_allow_time(e)
        }}>
          {fun.render_date_option().map((item: any) => <Select.Option key={item} value={item}>{item}</Select.Option>)}
        </Select>}
      </div>
      <div>
        {order_start_h !== '现在开始 / From Now' && <div style={{ marginTop: 10 }}>
          <Select style={{ width: 240, marginRight: 10 }} placeholder={current_language_ch ? '开始(时)' : 'START HOUR'} onChange={(e: any) => {
            set_order_start_h(e)
          }} options={common_fun.render_h_picker(start_date === fun.formatDate(new Date()) ? new Date().getHours() : 0)} />
          <Select style={{ width: 240, }} placeholder={current_language_ch ? '开始(分)' : 'START MINUTE'} onChange={(e: any) => set_order_start_m(e)} options={common_fun.render_m_picker} />
        </div>}
        <div style={{ marginTop: 10 }}>
          <Select style={{ width: 240, marginRight: 10 }} placeholder={current_language_ch ? '结束(时)' : 'END HOUR'} onChange={(e: any) => set_order_end_h(e)} options={([{ label: current_language_ch ? '当日结束' : 'Day Ended', value: '当日结束 / Day Ended' }]).concat(common_fun.render_h_picker(order_start_h === '' ? 0 : (order_start_h === '现在开始 / From Now' ? new Date().getHours() : Number(order_start_h))))} />
          {order_end_h !== '当日结束 / Day Ended' && <Select style={{ width: 240, }} placeholder={current_language_ch ? '结束(分)' : 'END MINUTE'} onChange={(e: any) => set_order_end_m(e)} options={common_fun.render_m_picker} />}
        </div>
        <Button onClick={() => {
          confirm_order()
        }} disabled={order_date.length === 0} loading={loading} type='primary' style={{ marginTop: 10 }}>{current_language_ch ? '确认预定' : 'CONFIRM BOOK'}</Button>
      </div>

      {current_language_ch ? <>
        <div style={{ fontSize: 16, marginTop: 15 }}>
          <div style={{ marginTop: 5 }}>* 结束时间选择【当日结束】，表示预定截止当日23:59:59</div>
          <div style={{ marginTop: 5 }}>* 折线高处为可预定时段，低处为不可预定时段</div>
          <div style={{ marginTop: 5, color: '#f50' }}><b>* {common_data.book_mention_1}</b></div>
          <div style={{ marginTop: 5, color: '#f50' }}><b>* {common_data.book_mention_2}</b></div>
          <div style={{ marginTop: 5, color: '#f50' }}><b>* {common_data.book_mention_3}</b></div>
        </div>
      </> : <>
        <div style={{ fontSize: 16, marginTop: 15 }}>
          <div style={{ marginTop: 5 }}>* Select [Day Ended] for the end time, which means that the booking is up to 23:59:59 of the day</div>
          <div style={{ marginTop: 5 }}>* The part above the broken line is the bookable period, and the part below the line is an unbookable period</div>
          <div style={{ marginTop: 5, color: '#f50' }}><b>* {common_data.book_mention_1}</b></div>
          <div style={{ marginTop: 5, color: '#f50' }}><b>* {common_data.book_mention_2}</b></div>
          <div style={{ marginTop: 5, color: '#f50' }}><b>* {common_data.book_mention_3}</b></div>
        </div>
      </>}
      <div style={{ overflowX: 'auto' }}>
        <ReactEcharts style={{ height: 200, width: '100%', marginTop: 15, minWidth: 700 }} option={{
          title: {
            text: start_date + ' ' + (order_start_h === '现在开始 / From Now' ? (current_language_ch ? '现在开始' : 'From Now') : order_start_h ? (order_start_h + ':' + order_start_m) : '') + ' ~ ' + (order_end_h === '当日结束 / Day Ended' ? (current_language_ch ? '当日结束' : 'Day Ended') : order_end_h ? (order_end_h + ':' + order_end_m + '') : '')
          },
          tooltip: {
            trigger: 'axis',
            valueFormatter: (params: any, index: any) => index
          },
          legend: {
            data: ['Step Start']
          },
          grid: {
            left: '0%',
            right: '2%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            data: order_date.map((item) => item['label'])
          },
          yAxis: {
            type: 'value',
            show: false
          },
          series: [
            {
              name: current_language_ch ? ' 预定状况 ' : ' Book status ',
              type: 'line',
              step: 'start',
              data: order_date.map((item) => item['allow_show'] ? 1 : 0)
            },
          ]
        }} />
      </div>
    </Modal>

    {/* 完善企业信息遮罩 */}
    <Modal width={500} destroyOnClose style={{ top: 10 }} visible={visible_my_info} footer={false} onCancel={() => { set_visible_my_info(false) }}>
      <ModifyInfo close_modal={() => { set_visible_my_info(false) }} my_co_info={my_co_info} is_only_confirm_info={is_only_confirm_info} />
    </Modal>

    {/* 左侧导航 */}
    {/* 非EVSE */}
    {!detail['demo_name'] && <>
      {!common_data.isMobile ? <div style={{ width: 320, float: 'left' }}><Spin spinning={loading}><Menu /></Spin></div> : <><div style={{ textAlign: 'right' }}><Button icon={<UnorderedListOutlined />} onClick={() => set_draw_visible(true)}>CPU {current_language_ch ? '菜单' : 'MENU'}</Button></div><Drawer title={'MENU'} width={250} onClose={() => set_draw_visible(false)} visible={draw_visible}><Menu /></Drawer></>}
    </>}

    {/* EVSE */}
    {detail['demo_name'] && <>
      {!common_data.isMobile ? <div style={{ width: 320, float: 'left' }}><Spin spinning={loading}><MenuSolution /></Spin></div> : <><div style={{ textAlign: 'right' }}><Button icon={<UnorderedListOutlined />} onClick={() => set_draw_visible(true)}>{current_language_ch ? '菜单' : 'MENU'}</Button></div><Drawer title={'MENU'} width={250} onClose={() => set_draw_visible(false)} visible={draw_visible}><MenuSolution /></Drawer></>}
    </>}

    {/* 右侧内容 */}
    <div style={{ width: common_data.isMobile ? '100%' : 'calc(100% - 330px)', float: 'right', marginTop: 10 }} >
      <Spin spinning={loading}>
        <div style={{ overflow: 'hidden' }}>
          {!detail['demo_name'] && <div className='nav_bread_box' style={{ marginTop: 5, alignItems: 'center', justifyContent: 'space-between' }}>
            {/* 面包屑导航 */}
            {detail.product_category ? <h3 className='nav_bread' style={{ marginLeft: '3%', color: '#8b8b8b', fontWeight: 'normal' }}>
              <MenuOutlined />
              <a style={{ marginLeft: 5 }} href={'/product/all' + (current_language_ch ? '' : '?lan=en')}>{current_language_ch ? '全部开发板' : 'Hardware'}</a>
              <a style={{ marginLeft: 5 }} href={'/product/' + common_data.url_board_match_set(detail.product_line, false) + (current_language_ch ? '' : '?lan=en')}>-&gt;{current_language_ch ? fun.get_chinese_menu(detail.product_line) : detail.product_line}</a>
              <a style={{ marginLeft: 5 }} href={'/product-' + common_data.url_board_match_set(detail.product_line, false) + '/' + detail.format_url_board_product_category + (current_language_ch ? '' : '?lan=en')}>-&gt;{current_language_ch ? fun.get_chinese_menu(detail.product_category) : detail.product_category}</a>
              <a style={{ marginLeft: 5 }} href={'/product-' + common_data.url_board_match_set(detail.product_line, false) + '/' + detail.format_url_board_product_category + '/' + detail.format_url_board_cpu_family + (current_language_ch ? '' : '?lan=en')}>-&gt;{detail.cpu_family}</a>
              <span style={{ marginLeft: 5 }}>-&gt;{detail.name_no_num}</span>
            </h3> : <h3></h3>}

            {/* 右侧按钮 */}
            <h3 className='learn_more' style={{}}>{((detail['c_url'] && current_language_ch) || (detail['e_url'] && !current_language_ch)) && <a href={current_language_ch ? detail['c_url'] : detail['e_url']} target={'_blank'} style={{ color: '#5e5e5e' }}>{current_language_ch ? '了解更多开发板信息' : 'Learn more about the board'} <ExportOutlined /></a>}</h3>
          </div>}

          {/* 上面开发板名称，预定/我的按钮 */}
          <div style={{ clear: 'both' }}>
            {!common_data.isMobile && <div style={{ float: 'left', width: '35%' }} className='shdow_big'>
              {detail['lab_state'] !== 'active' ? <Tag color={'#a5a5a5'}>{current_language_ch ? '维护中' : 'MAINTENANCE'}</Tag> : detail['claimed_on'] && (detail['claimed_on'] <= fun.formateTime(new Date())) ? <Tag color={'#f50'}>{current_language_ch ? '正在被使用中' : 'OCCUPIED NOW'}</Tag> :
                <Tag color={'#69CA00'}>{current_language_ch ? '可立即使用' : 'AVAILABLE NOW'}</Tag>}
              {detail['demo_name'] ? (current_language_ch ? detail['evse_title_ch'] : detail['evse_title_en']) :
                detail['name_no_num']} {!detail['demo_name'] && <i style={{ color: '#1890ff' }}>#{detail['num']}</i>}
            </div>}

            <div onClick={() => {
              // 检测是否有登录
              if (!fun.check_login(true)) {
                return
              }

              // 检测板子是否维护中
              if (detail['lab_state'] !== 'active') {
                message.info(current_language_ch ? '开发板正在维护中，请预定其他开发板' : 'The board is under maintenance, please book other board')
                return
              }

              let u_name = cookie.load('login_username')
              console.log('详情页页获取login_username', u_name, detail['demo_name'])
              // if (u_name !== '17640181459@163.com' && u_name !== '17640181459@163.com') {
              //   if (detail['demo_name'] && (u_name.indexOf('@') !== -1)) {
              //     message.info(current_language_ch ? 'EVSE开发板正在维护中，请预定其他开发板' : 'The EVSE board is under maintenance, please book other board')
              //     return
              //   }
              // }


              // 检测是否已完善企业名称信息
              set_loading_btn(true)
              fun['post_data'](url + 'get_my_info', {}).then(res => {
                if (res.status) {
                  console.log(res.result)
                  // 打开更新个人信息遮罩
                  const update_info_modal = () => {
                    set_loading_btn(false)
                    set_visible_my_info(true)
                    set_my_co_info(res.result)
                  }
                  if ((res.result.is_mainland_China && res.result.company && res.result.mobile && res.result.send_sms_code_time) || (!res.result.is_mainland_China && res.result.company_en) || res.result.company === '恩智浦') {
                    // 身份信息是否过期
                    if (!res.result.last_update_info_time) {
                      update_info_modal()
                      set_is_only_confirm_info(true)
                      return
                    }

                    let info_has_update_seconds = (new Date().getTime() - new Date(res.result.last_update_info_time.slice(0, 19).replace('T', ' ')).getTime()) / 1000
                    if (info_has_update_seconds > 3600 * 24 * 14) {
                      // if (info_has_update_seconds > 360) {
                      update_info_modal()
                      set_is_only_confirm_info(true)
                      return
                    }

                    fun['post_data'](url + 'get_video_url', { board_name }).then(res => {
                      if (!res.status) {
                        alert(current_language_ch ? ('可能无法观看视频：' + JSON.stringify(res.result)) : ('May not be able to watch videos: ' + JSON.stringify(res.result_en)))
                      }

                      set_visible(true)
                      set_order_date([])
                      set_order_start_h('')
                      set_order_start_m('')
                      set_order_end_h('')
                      set_order_end_m('')
                      get_allow_time(fun.formatDate(new Date()))
                      set_loading_btn(false)
                    })
                  } else {
                    update_info_modal()
                  }
                } else {
                  set_loading_btn(false)
                  alert(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
                }
              })
            }} style={{ width: common_data.isMobile ? '45%' : '25%', backgroundColor: detail['lab_state'] === 'active' ? '#F9B500' : '#acacac' }} className='watch_btn'><Spin spinning={loading_btn}>{current_language_ch ? (cookie.load('login_username') ? '立即预定' : '登录后可预订') : (cookie.load('login_username') ? 'BOOK NOW' : 'LOGIN TO BOOK')} <GiftOutlined /></Spin></div>
            <div onClick={() => {
              if (cookie.load('login_username')) {
                window.location.href = '/my' + (current_language_ch ? '' : '?lan=en')
              } else {
                message.info(current_language_ch ? '请登录后可查看' : 'Please login to check')
              }
            }} style={{ backgroundColor: cookie.load('login_username') ? '#69CA00' : '#acacac', borderColor: '#69CA00', width: common_data.isMobile ? '45%' : '25%' }} className='watch_btn'>{current_language_ch ? '我的预定' : 'MY BOOKS'} <VideoCameraAddOutlined /></div>
          </div>
        </div>
        <div style={{ clear: 'both', height: 20 }}></div>

        <div className='shdow_bot' style={{ width: common_data.isMobile ? '94%' : '35%', marginLeft: '3% ', overflow: 'hidden', float: 'left' }}>
          {detail['img_path'] && <img style={{ width: '100%' }} src={detail['img_path'].indexOf('http') === 0 ? detail['img_path'] : ('https://www.nxp.com.cn/' + detail['img_path'])} />}

          {/* 无回传画面提示 */}
          {!detail['screen_haikang_code'] && <div style={{ width: '96%', margin: '5px auto 5px', color: '#ff3636', fontSize: 15 }}>* {current_language_ch ? '暂无显示器画面' : 'There is currently no display screen available'}</div>}

          {/* 外设 */}
          {detail['external_device'] && <div style={{ width: '96%', margin: '5px auto 10px' }}>
            <div style={{ fontFamily: 'PoppinsBold', fontWeight: 'bold', fontSize: 17 }}>{current_language_ch ? '外接设备' : 'External Device'}</div>
            {detail['external_device'].split(';').map((item: any) => <div key={item}>
              {item.indexOf('screen:') === 0 ? <div className='external_box'>
                <img src={screen_png} />
                <span style={{ fontSize: 15, marginRight: 6, marginLeft: 4 }}>{current_language_ch ? '屏幕' : 'Screen'}:</span><span>{item.replace('screen:', '')}</span>
              </div> : item.indexOf('camera:') === 0 ? <div className='external_box'>
                <img src={camera_png} />
                <span style={{ fontSize: 15, marginRight: 6, marginLeft: 4 }}>{current_language_ch ? '摄像头' : 'Camera'}:</span><span>{item.replace('camera:', '')}</span>
              </div> : <div></div>}
            </div>)}
          </div>}

          {/* 功能体验 */}
          {detail['function_experience'] && <div style={{ width: '96%', margin: '10px auto 10px' }}>
            <div style={{ fontFamily: 'PoppinsBold', fontWeight: 'bold', fontSize: 17 }}>{current_language_ch ? '功能体验' : 'User Guide'}</div>
            {JSON.parse(detail['function_experience']).map((item: any, index: number) => <div className='external_box' style={{ fontSize: 15 }} key={index}>
              <a target={'_blank'} href={url + (current_language_ch ? item.url_ch : item.url_en)} style={{ color: '#215bd6' }}>{current_language_ch ? item.name_ch : item.name_en}</a>
            </div>)}
          </div>}
        </div>

        {/* EVSE或ddr */}
        {(detail['demo_name'] || detail['type'] === 'DDR-Configuration') ? <div className='shdow_bot' style={{ width: common_data.isMobile ? '94%' : '54%', overflow: 'hidden', float: "right", marginRight: common_data.isMobile ? '3%' : '6%', padding: '1%', marginTop: common_data.isMobile ? 10 : 0 }}>
          <h2 style={{ textAlign: 'center' }}>{current_language_ch ? (detail['evse_title_ch'] || '暂无标题') : (detail['evse_title_en'] || '')}</h2>
          <div dangerouslySetInnerHTML={{ __html: current_language_ch ? (detail['evse_remarks_ch'] || '暂无简介') : (detail['evse_remarks_en'] || 'No introduction available at the moment') }}></div>
        </div> : < div className='shdow_bot' style={{ width: common_data.isMobile ? '94%' : '54%', overflow: 'hidden', float: "right", marginRight: common_data.isMobile ? '3%' : '6%', padding: '1%', marginTop: common_data.isMobile ? 10 : 0 }}>
          {/* 非EVSE 非ddr */}
          {detail['detail'] ? <div style={{ overflow: "hidden" }}>
            <h2 style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: !detail['detail'] ? detail['cpu_family'] : (current_language_ch ? (detail['detail_parse'])[0]['data_set'][0] : (detail['detail_parse'])[0]['data_set_en'][0]) }}></h2>
            {detail['detail_parse'].map((item: any, index: number) => <div style={{
              borderBottom: '2px solid #e0e0e0', paddingBottom: 15, marginTop: 10,
              display: ((current_language_ch && item['data_set']['length'] > 0) || (!current_language_ch && item['data_set_en']['length']) > 0) ? 'block' : 'none'
            }} key={index}>
              <h3 style={{ fontWeight: 'bold', color: '#215bd6' }}>{current_language_ch ? (item['title'][0] === '能源管理' ? '电源管理' : item['title'][0]) : item['key']}</h3>
              {current_language_ch ? <div>{item['data_set'].map((item2: any) => <div key={item2} dangerouslySetInnerHTML={{ __html: item2 }}></div>)}</div> : <div>{item['data_set_en'].map((item2: any) => <div key={item2} dangerouslySetInnerHTML={{ __html: item2 }}></div>)}</div>}
            </div>)}
          </div> : <div style={{ textAlign: 'center' }}>No Data</div>}
        </div>}
        <div style={{ clear: 'both', height: 30 }}></div>
      </Spin>
    </div >
  </div >
}

export default App;